import Section from '../Section';

export default class CollectionFilterSort extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);
    this.mobileSidebar();
  }

  mobileSidebar = () => {
    $('.collection-sidebar--section h2').on('click', function () {
      var $this = $(this);
      var parent = $this.parent();
      parent.toggleClass('expanded');
    });
  }
}